import React, { useContext } from 'react'
import { EmployerContext } from '../../templates/GenericEmployer/GenericEmployer'
import useSelectTextColor from '../../../../common/hooks/useSelectTextColor'

function GenericEmployerBanner({ data, primaryColor }) {

    const employer = useContext(EmployerContext)
    const colorSelector = useSelectTextColor()
    const logo = data.company_logo ? data.company_logo : employer.logo?.file
    const showLogo = data.show_logo !== false
    const showTitle = data.show_title !== false
    const usesHeroImage = Boolean(
        data.image && (Object.prototype.hasOwnProperty.call(data, 'show_logo') || Object.prototype.hasOwnProperty.call(data, 'show_title'))
    )

    const identity = (
        <div className="banner-left">
            {showLogo && logo && (
                <div className="logo">
                    <img src={logo} alt="" />
                </div>
            )}
            {showTitle && (
                <h1 style={{ color: colorSelector(primaryColor) }}>{data.title}</h1>
            )}
        </div>
    )

    if (usesHeroImage) {
        const hasIdentity = (showLogo && logo) || (showTitle && data.title)

        return (
            <section className={`company-banner banner company-banner--hero${hasIdentity ? '' : ' company-banner--image-only'}`}>
                <div className="banner-hero">
                    <img src={data.image} alt="" />
                </div>
                {hasIdentity && (
                    <div className="banner-hero-content">
                        <div className="container">
                            {identity}
                        </div>
                    </div>
                )}
            </section>
        )
    }

    return (
        <section className="company-banner banner">
            <div className="container">
                <div className="banner-sub row">
                    <div className={data.image ? "col-md-6" : "col-md-12"}>
                        {identity}
                    </div>
                    <div className="col-md-6">
                        <div className="banner-right">
                            <img src={data.image} alt="" />
                        </div>
                    </div>
                </div>  
            </div>
        </section>
    )
}

export default GenericEmployerBanner
